module.exports = __webpack_public_path__ + "media/tema_1_warning1_a_CF1.19944caf.wav";